import React from 'react';
import { View, Text } from 'react-native';

import { CloseIcon } from '../widgets/Common-Widget';
import { PrimaryCTA, SecondaryCTA } from '../widgets/CommonCTA';

import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';

const BottomSheetModal = (props) => {
    const showModal = props.showModal
    const modalData = props.modalData
    const closeModal = props.closeModal
    const primaryAction = props.primaryAction
    const secondaryAction = props?.secondaryAction
    const hasSecondaryCTA = props?.hasSecondaryCTA ?? false
    return <Modal key={modalData.ctaTitle}
        isVisible={showModal} hasBackdrop={true}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        style={[AppStyles.alignCenter, { marginBottom: 0 }]}
        onBackdropPress={() => closeModal()}>
        <View style={[AppStyles.bottomFix, AppStyles.topBorderView, {
            width: AppTheme.appWidth, padding: 16, margin: "auto"
        }]}>
            <View style={[AppStyles.flexRowSpaceBetween]}>
                <Text style={[TextStyle.text20b]}>
                    {modalData.title}</Text>
                <CloseIcon action={() => closeModal()} />
            </View>

            <Text style={[TextStyle.text14, { marginTop: 18, marginBottom: 36 }]}>
                {modalData.subTitle}</Text>

            {hasSecondaryCTA ? <View style={[AppStyles.flexRowSpaceBetween]}>
                <SecondaryCTA width={AppTheme.appWidth / 2 - 24}
                    text={modalData.secondaryCTATitle}
                    action={() => { closeModal(); secondaryAction() }} />
                <View style={{ width: 16 }} />
                <PrimaryCTA width={AppTheme.appWidth / 2 - 24}
                    text={modalData.primaryCTATitle}
                    action={() => { closeModal(); primaryAction() }} />
            </View> : <PrimaryCTA width={AppTheme.appWidth - 32}
                text={modalData.ctaTitle}
                action={() => { closeModal(); primaryAction() }} />}

        </View>
    </Modal>
}

export default BottomSheetModal